import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { signIn, getCurrentUser, signOut } from 'aws-amplify/auth';
import { Amplify } from 'aws-amplify';
import { generateClient } from 'aws-amplify/api';
import awsExports from '../../../aws-exports';
import '@aws-amplify/ui-react/styles.css';
import { listMatchMakers } from '../../../graphql/queries';

// ✅ No crypto-browserify

Amplify.configure(awsExports);
const client = generateClient();

const Main = () => {
    const [errorMessage, setErrorMessage] = useState('');
    const navigate = useNavigate();

    const TIKTOK_CLIENT_KEY = 'sbawuqmkdx3ntukp5c';
    const REDIRECT_URI = 'https://misoulmate.com/tiktok/callback';
    const SCOPES = 'user.info.basic,video.upload,video.publish';

    // ✅ No PKCE
    const tiktokAuthUrl = `https://www.tiktok.com/v2/auth/authorize?client_key=${TIKTOK_CLIENT_KEY}&response_type=code&scope=${encodeURIComponent(SCOPES)}&redirect_uri=${encodeURIComponent(REDIRECT_URI)}&state=secure123`;

    const handleSubmit = async (event) => {
        event.preventDefault();
        const form = event.currentTarget;
        const username = form.elements.username.value;
        const password = form.elements.password.value;

        if (!username) {
            setErrorMessage("Email is required");
            return;
        }
        if (!password) {
            setErrorMessage("Password is required");
            return;
        }

        try {
            await signOut();
            await signIn({
                username,
                password,
                options: { authFlowType: 'USER_PASSWORD_AUTH' }
            });

            const currentUser = await getCurrentUser();
            const userId = currentUser.userId;

            const matchMakersData = await client.graphql({ query: listMatchMakers });
            const matchMaker = matchMakersData.data.listMatchMakers.items.find(mm => mm.username === username);

            if (matchMaker) {
                navigate(`/matchmaker-home/${matchMaker.id}`);
            } else {
                setErrorMessage("MatchMaker data not found");
            }
        } catch (error) {
            console.log("Error during sign-in:", error);
            setErrorMessage(error.message);
        }
    };

    return (
        <>
            <div className="page_wrapper">
                <div className="full_bg">
                    <div className="container">
                        <section className="signup_section">
                            <div className="top_part">
                                <Link to="/" className="back_btn">
                                    <i className="icofont-arrow-left"></i> Back
                                </Link>
                            </div>
                            <div className="signup_form">
                                <div className="section_title">
                                    <h2>
                                        Welcome to <span>MiSoulmate</span>
                                    </h2>
                                    <p>
                                        Log in to access the Match Maker dashboard and manage matches efficiently.
                                    </p>
                                </div>
                                <form onSubmit={handleSubmit}>
                                    <div className="form-group">
                                        <input
                                            type="username"
                                            name="username"
                                            className="form-control"
                                            placeholder="Email"
                                        />
                                    </div>
                                    <div className="form-group">
                                        <input
                                            type="password"
                                            name="password"
                                            className="form-control"
                                            placeholder="Password"
                                        />
                                    </div>
                                    {errorMessage && (
                                        <p style={{ color: 'red' }}>{errorMessage}</p>
                                    )}
                                    <div className="form-group">
                                        <button className="btn puprple_btn" type="submit">
                                            SIGN IN
                                        </button>
                                    </div>

                                    {/* ✅ TikTok Connect Button (under SIGN IN) */}
                                    {/* <div className="form-group">
                                        <button
                                            className="btn puprple_btn"
                                            type="button"
                                            onClick={() => window.location.href = tiktokAuthUrl}
                                        >
                                            Connect TikTok Account
                                        </button>
                                    </div> */}
                                </form>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Main;
